export default __webpack_public_path__ + "static/fondo-pag-1_3-edde091124df5be121a49d9556fc44c6.jpg";